// extracted by mini-css-extract-plugin
export var text = "_41-0";